import React from 'react';
import * as S from './FileAddButton.style';

const FileAddButton = ({ onClick }) => {
  const handleClick = () => {
    onClick?.();
  };

  return (
    <S.AddButtonContainer onClick={handleClick}>
      <S.AddIcon className="add-icon">+</S.AddIcon>
      <S.AddText className="add-text">데이터 추가</S.AddText>
    </S.AddButtonContainer>
  );
};

export default FileAddButton;